import {
  createContext,
  type Dispatch,
  type SetStateAction,
  useContext,
} from "react";

import { type TFlightFormValues } from "@/types/types";

export interface FlightSearchDataContextValue {
  searchData: TFlightFormValues | null;
  updateSearchData: Dispatch<SetStateAction<TFlightFormValues | null>>;
}

export const FlightSearchDataContext =
  createContext<FlightSearchDataContextValue | null>(null);

export const useFlightSearchDataContext = () => {
  const context = useContext(FlightSearchDataContext);
  if (!context) {
    throw new Error(
      "useFlightSearchDataContext must be used within a FlightSearchDataProvider",
    );
  }
  return context;
};
